import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  CheckCircleOutlined,
  KeyOutlined,
  CalendarOutlined,
  SolutionOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <KeyOutlined />,
  1: <CalendarOutlined />,
  2: <SolutionOutlined />,
  3: <BarChartOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("hrm");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");
  const statSecondaryValue = t("highlights.stat_secondary_value");
  const statSecondaryLabel = t("highlights.stat_secondary_label");

  return (
    <section className="dev-hrm-section dev-hrm-highlights-section">
      <div className="dev-hrm-section-inner">
        <h2 className="dev-section-h2 dev-hrm-section-h2">
          <span className="dev-hrm-section-h2-icon dev-hrm-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-hrm-highlights-grid">
          <div className="dev-hrm-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-hrm-highlight-item">
                <div className="dev-hrm-highlight-icon">
                  {iconByIndex[idx] ?? <CheckCircleOutlined />}
                </div>
                <div>
                  <div className="dev-hrm-highlight-title">{item.title}</div>
                  <div className="dev-hrm-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-hrm-stat-card dev-hrm-stat-card--dual">
            <div className="dev-hrm-stat-dual-grid">
              <div className="dev-hrm-stat-dual-item">
                <div className="dev-hrm-stat-value">{statValue}</div>
                <div className="dev-hrm-stat-label">{statLabel}</div>
              </div>
              <div className="dev-hrm-stat-dual-divider" aria-hidden />
              <div className="dev-hrm-stat-dual-item">
                <div className="dev-hrm-stat-value dev-hrm-stat-value--secondary">{statSecondaryValue}</div>
                <div className="dev-hrm-stat-label">{statSecondaryLabel}</div>
              </div>
            </div>
            <div className="dev-hrm-stat-desc">{statDesc}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
